import { Component, HostListener, Input } from '@angular/core';
import { UtilsService } from 'src/app/shared/services';

declare var $: any;

@Component({
    selector: 'app-transaction-logs',
    templateUrl: './transaction-logs.component.html',
    styleUrls: ['./transaction-logs.component.scss'],
    standalone: false
})
/**
 *  details = {
      itemName,
      transactionHistory,
    };

    Make object as above to use transation logs component
 */
export class TransactionLogsComponent {
  @HostListener('window:popstate', ['$event'])
  onPopState(event: Event): void {
    this.fnCloseModal();
  }
  @Input() headingTitle: string = 'Invoice';
  transactionLog: any = [];
  itemName: string = '';
  offerLetterTableHeaders = ['Time', 'Action', 'Level', 'User', 'Remarks'];
  invoiceTableHeaders = ['Time', 'Action', 'User', 'Remarks'];
  serviceRequestTableHeaders = [
    'Time',
    'Status From',
    'Status To',
    'User',
    'Remarks',
  ];

  tableHeaders: string[] = [];

  constructor(public utilsService: UtilsService) {}

  ngOnInit(): void {
    if (this.headingTitle === 'Invoice') {
      this.tableHeaders = this.invoiceTableHeaders;
    } else if (
      ['Offer Letter', 'My Offer Letter', 'Expense', 'My Expense'].includes(
        this.headingTitle
      )
    ) {
      this.tableHeaders = this.offerLetterTableHeaders;
    } else if (this.headingTitle === 'Service Request') {
      this.tableHeaders = this.serviceRequestTableHeaders;
    }
  }

  fnOpenModal(details: any) {
    $('#transactionLogModal').modal('show');
    this.transactionLog = details.transactionHistory;
    this.itemName = details.itemName;
  }

  fnCloseModal() {
    $('#transactionLogModal').modal('hide');
  }

  fnTruncateAdditionalComments(comment: string) {
    let truncateString = '';
    if (comment) {
      if (comment.length < 30) {
        truncateString = comment;
      } else {
        truncateString = `${this.utilsService.fnTruncateString(
          comment,
          0,
          30
        )}...`;
      }
    } else {
      truncateString = '-';
    }
    return truncateString;
  }

  fnGetStatusColor(status: string) {
    let color: string = '';
    if (status === 'REJECTED') {
      color = '#d70015';
    } else if (status === 'SUBMITTED') {
      color = '#cbcb00';
    } else if (status === 'APPROVED') {
      color = 'green';
    } else if (status === 'CANCELLED') {
      color = '#c93400';
    } else if (status === 'REVOKED') {
      color = '#c93400';
    } else if (status === 'OFFERED') {
      color = '#334AA5';
    } else if (status === 'REIMBURSED') {
      color = '#334AA5';
    }
    return color;
  }

  fnGetServiceRequestStatusColor(status: string) {
    let color: string = '';
    if (status === 'New') {
      color = '#607D8B';
    } else if (status === 'Assigned') {
      color = '#78C249';
    } else if (status === 'In-progress') {
      color = '#FF9800';
    } else if (status === 'On-Hold') {
      color = '#FF9800';
    } else if (status === 'Resolved') {
      color = '#4CAF50';
    } else if (status === 'Closed') {
      color = '#5DA9D1';
    } else {
      color = '#607D8B';
    }
    return color;
  }

  getLabel(comment: string, maxLimit: number) {
    return this.utilsService.getLabel(comment, maxLimit);
  }
}
